export default "<template>\r\n  <div class=\"text-center\">\r\n    <v-btn rounded color=\"primary\" dark>Rounded Button</v-btn>\r\n  </div>\r\n</template>\r\n";